function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "40",
  height: "40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M3 13l-.65-.76-.35.3V13h1zm0 20H2v1h1v-1zm27 0v1h.37l.28-.24L30 33zm7-6l.65.76.35-.3V27h-1zm0-20h1V6h-1v1zM10 7V6h-.37l-.28.24L10 7zm-8 6v20h2V13H2zm1 21h27v-2H3v2zm27.65-.24l7-6-1.3-1.52-7 6 1.3 1.52zM38 27V7h-2v20h2zM36.35 6.24l-7 6 1.3 1.52 7-6-1.3-1.52zM30 12H3v2h27v-2zm1 21V13h-2v20h2zM3.65 13.76l7-6-1.3-1.52-7 6 1.3 1.52zM10 8h27V6H10v2z",
  fill: "#000"
})));